module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header_second_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "logo_box"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/logo.png",
      "alt": "logo"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "rolunk_btn"
  }, [_c('div', {
    staticClass: "rolunk_btn_box"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_vm._v("WEBSHOP")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.webstoreLink
    }
  }, [_vm._v("RÓLUNK")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "box_search"
  }, [_c('div', {
    staticClass: "box_search_box"
  }, [_c('div', {
    staticClass: "blog_search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "best",
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Keresés..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog_search_btn"
  }, [_c('span', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce04866","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/Header2.vue
// module id = 283
// module chunks = 2